import Price from '../../Price'
import { SummaryListItemProps } from '../SummaryList.types'
import { getTotalDiscounts } from '../SummaryList.utils'
import {
  SummaryItemContainer,
  ItemUnitDescription
} from './SummaryListItem.style'

import {
  PriceDetail,
  ProductQuantityWrapper,
  ProductDetails,
  PricePerUnit,
  ProductName
} from '../SummaryList.styles'
import { PackageType } from '../../../../interfaces/enums'

const SummaryListItem = (props: SummaryListItemProps) => {
  const {
    item: {
      quantity,
      name,
      price = 0,
      description = '',
      totalFee,
      promotion,
      packageType
    },
    priceProps,
    fieldsToDisplay
  } = props
  const isHalfBox = packageType === PackageType.HALFBOX
  const showProductFee = fieldsToDisplay?.includes('totalFee')
  const finalQty = isHalfBox ? quantity / 2 : quantity
  const totalizedPrice = price * finalQty

  return (
    <SummaryItemContainer>
      {fieldsToDisplay?.includes('quantity') && (
        <ProductQuantityWrapper className="ProductQuantity">
          {finalQty}
        </ProductQuantityWrapper>
      )}
      <ProductDetails>
        {fieldsToDisplay?.includes('name') && <ProductName>{name}</ProductName>}
        {fieldsToDisplay?.includes('description') && (
          <ItemUnitDescription
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {fieldsToDisplay?.includes('unitPrice') && (
          <PricePerUnit value={price} {...priceProps} />
        )}
      </ProductDetails>
      <PriceDetail>
        <Price
          wrapContent
          discountOrder={1}
          priceOrder={2}
          value={totalizedPrice}
          fee={showProductFee ? totalFee : undefined}
          discount={getTotalDiscounts(promotion?.value, quantity)}
          {...priceProps}
        />
      </PriceDetail>
    </SummaryItemContainer>
  )
}

export default SummaryListItem
